const aboutData = {
  name: "Ashlynn Braisted",
  role: "Software Engineer",
  intro: [
    <>
      I'm a detail-oriented <span className="bold">web developer</span> with a
      passion for creating human-centered, interactive experiences. I recently
      graduated from Northeastern University with a
      <span className="bold"> BS </span> in
      <span className="bold"> Computer Science and Interaction Design</span>.
    </>,
    <>
      During my studies, I completed two 6-month full-time Web Development
      positions, led a mentorship program teaching foundational coding skills to
      middle school girls as president of Girls Who Code, and photographed
      concerts for <i>Tastemakers</i> magazine.
    </>,
    <>
      Outside of work, I love to hike, crochet, and play <i>Catan</i>. Take a
      look around to see some of my work!
    </>,
  ],
  publications: [
    {
      label: "A Conversation With Kerry Tribe",
      href: "https://voca.network/blog/2022/07/06/a-conversation-with-kerry-tribe-exploring-cognizance-and-interaction/",
    },
    {
      label: "TMM Issue 65, Pg. 32",
      href: "https://www.tastemakersmag.com/issue/issue-65-cmamm",
    },
    {
      label: "TMM Issue 68, Pg. 23, 44",
      href: "https://www.tastemakersmag.com/issue/issue68-ba46l",
    },
    {
      label: "TMM Online",
      href: "https://www.tastemakersmag.com/photos?offset=1634058300879&reversePaginate=true&author=678fde4809c59c4443712fbe",
    },
  ],
  links: {
    linkedin: "https://www.linkedin.com/in/ashlynnbraisted/",
    email: "ashlynnbraisted@gmail.com",
    github: "https://github.com/ashlynnbraisted",
  },
};

export default aboutData;
